export const IngredientData =
[
    {
        "id": 1,
        "type": "D",
        "name": "B-1",
        "altName": "Thiamin",
        "source": "Thiamin HCL",
        "class": "vitamin"
    },
    {
        "id": 2,
        "type": "D",
        "name": "B-2",
        "altName": "Riboflavin",
        "source": "",
        "class": "vitamin"
    },
    {
        "id": 3,
        "type": "D",
        "name": "B-3",
        "altName": "Niacin",
        "source": "Niacinamide",
        "class": "vitamin"
    },
    {
        "id": 4,
        "type": "D",
        "name": "B-6",
        "altName": "",
        "source": "Pyridoxine HCL",
        "class": "vitamin"
    },
    {
        "id": 5,
        "type": "D",
        "name": "B-12",
        "altName": "",
        "source": "Cyanocobalamin",
        "class": "vitamin"
    }
]